import { icons } from 'lucide-react';
import { ROLE } from './enum';

interface AgentType {
  agent: string;
  icon: keyof typeof icons;
  view: string;
  centerView: string;
}

const AgentMap: AgentType[] = [
  {
    agent: 'web',
    icon: 'Globe',
    view: 'Webchat',
    centerView: 'Webchat',
  },
  {
    agent: 'facebook',
    icon: 'Facebook',
    view: 'Facebook',
    centerView: 'Facebook Messenger',
  },
  {
    agent: 'instagram',
    icon: 'Instagram',
    view: 'Instagram',
    centerView: 'Instagram Direct Messaging',
  },
  {
    agent: 'email',
    icon: 'Mail',
    view: 'Email',
    centerView: 'Email',
  },
  {
    agent: 'whatsapp',
    icon: 'MessageCircle',
    view: 'WhatsApp',
    centerView: 'WhatsApp',
  },
  {
    agent: 'sms',
    icon: 'MessageSquare',
    view: 'SMS',
    centerView: 'SMS',
  },
  {
    agent: 'viber',
    icon: 'Send',
    view: 'Viber',
    centerView: 'Viber',
  },
  {
    agent: 'outboundcall',
    icon: 'Phone',
    view: 'Phone',
    centerView: 'Phone',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Call',
    centerView: 'Phone',
  },
  {
    agent: 'form',
    icon: 'Notebook',
    view: 'Form',
    centerView: 'Form',
  },
  {
    agent: 'internet',
    icon: 'Globe',
    view: 'Internet',
    centerView: 'Internet',
  },
  {
    agent: 'organic',
    icon: 'Globe',
    view: 'Organic Form',
    centerView: 'Organic',
  },
  {
    agent: 'paid - meta',
    icon: 'Notebook',
    view: 'Paid Meta',
    centerView: 'Paid Meta',
  },
  {
    agent: 'paid - google',
    icon: 'MessageCircle',
    view: 'Paid Google',
    centerView: 'Paid Google',
  },
  {
    agent: 'paid - other',
    icon: 'Mail',
    view: 'Paid Other',
    centerView: 'Paid Other',
  },
];

const AgentMapInsights: AgentType[] = [
  {
    agent: 'web',
    icon: 'Globe',
    view: 'Webchat',
    centerView: 'Webchat',
  },
  {
    agent: 'facebook',
    icon: 'Facebook',
    view: 'Facebook',
    centerView: 'Facebook Messenger',
  },
  {
    agent: 'instagram',
    icon: 'Instagram',
    view: 'Instagram',
    centerView: 'Instagram Direct Messaging',
  },
  {
    agent: 'email',
    icon: 'Mail',
    view: 'Email',
    centerView: 'Email',
  },
  {
    agent: 'whatsapp',
    icon: 'MessageCircle',
    view: 'WhatsApp',
    centerView: 'WhatsApp',
  },
  {
    agent: 'sms',
    icon: 'MessageSquare',
    view: 'SMS',
    centerView: 'SMS',
  },
  {
    agent: 'form',
    icon: 'Notebook',
    view: 'Form',
    centerView: 'Form',
  },
];

const MultiAgentMap: AgentType[] = [
  {
    agent: 'whatsapp',
    icon: 'MessageCircle',
    view: 'WhatsApp',
    centerView: 'WhatsApp',
  },
  {
    agent: 'sms',
    icon: 'MessageSquare',
    view: 'Sms',
    centerView: 'Sms',
  },
  {
    agent: 'email',
    icon: 'Mail',
    view: 'Email',
    centerView: 'Email',
  },
  {
    agent: 'web',
    icon: 'MessageSquare',
    view: 'Webchat',
    centerView: 'Webchat',
  },
  {
    agent: 'instagram',
    icon: 'Instagram',
    view: 'Instagram',
    centerView: 'Instagram Direct Messaging',
  },
  {
    agent: 'facebook',
    icon: 'Facebook',
    view: 'Facebook',
    centerView: 'Facebook Messenger',
  },
  {
    agent: 'outboundcall',
    icon: 'Phone',
    view: 'Voice',
    centerView: 'Voice',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Call',
    centerView: 'Phone',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'InBound',
    centerView: 'InBound',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Call',
    centerView: 'Phone',
  },
];

const SalesMap: any[] = [
  {
    agent: 'form',
    icon: 'Globe',
    view: 'Webform',
    centerView: 'Webform',
  },
  {
    agent: 'whatsapp',
    icon: 'MessageCircle',
    view: 'WhatsApp',
    centerView: 'WhatsApp',
  },
  {
    agent: 'sms',
    icon: 'MessageSquare',
    view: 'SMS',
    centerView: 'SMS',
  },
  {
    agent: 'email',
    icon: 'Mail',
    view: 'Email',
    centerView: 'Email',
  },
  {
    agent: 'web',
    icon: 'Globe',
    view: 'Webchat',
    centerView: 'Webchat',
  },
  {
    agent: 'instagram',
    icon: 'Instagram',
    view: 'Instagram',
    centerView: 'Instagram Direct Messaging',
  },
  {
    agent: 'facebook',
    icon: 'Facebook',
    view: 'Facebook',
    centerView: 'Facebook Messenger',
  },
  {
    agent: 'tiktok',
    icon: 'Notebook',
    view: 'Tiktok',
    centerView: 'Tiktok',
  },
];

const ConversationAgentMap: AgentType[] = [
  {
    agent: 'viber',
    icon: 'Send',
    view: 'Viber',
    centerView: 'Viber',
  },
  {
    agent: 'whatsapp',
    icon: 'MessageCircle',
    view: 'WhatsApp',
    centerView: 'WhatsApp',
  },
  {
    agent: 'sms',
    icon: 'MessageSquare',
    view: 'SMS',
    centerView: 'SMS',
  },
  {
    agent: 'email',
    icon: 'Mail',
    view: 'Email',
    centerView: 'Email',
  },
  {
    agent: 'web',
    icon: 'Globe',
    view: 'Webchat',
    centerView: 'Webchat',
  },
  {
    agent: 'instagram',
    icon: 'Instagram',
    view: 'Instagram',
    centerView: 'Instagram Direct Messaging',
  },
  {
    agent: 'facebook',
    icon: 'Facebook',
    view: 'Facebook',
    centerView: 'Facebook Messenger',
  },
  {
    agent: 'outboundcall',
    icon: 'Phone',
    view: 'Phone',
    centerView: 'Phone',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Call',
    centerView: 'Phone',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Phone (InBound)',
    centerView: 'Phone',
  },
  {
    agent: 'inboundcall',
    icon: 'Phone',
    view: 'Call (InBound)',
    centerView: 'Phone',
  },
  // Voice calls placed through the web widget. A distinct channel from `web`,
  // which is web CHAT — the two are unrelated despite the similar name.
  {
    agent: 'webcall',
    icon: 'Phone',
    view: 'Web Call',
    centerView: 'Web Call',
  },
];

const menuItems = [
  {
    icon: 'Building' as keyof typeof icons,
    pathname: '/clients',
    title: 'Clients',
    permissionKey: 'clients:list',
    permission: [ROLE.SUPEROWNER, ROLE.USERKEEPME, ROLE.KEEPME]
  },
  {
    icon: 'Command' as keyof typeof icons,
    pathname: '/account',
    title: 'Configurations',
    permissionKey: 'settings:read',
  },
  {
    icon: 'Users' as keyof typeof icons,
    pathname: '/team',
    title: 'Team',
    permissionKey: 'team:read',
  },
  {
    icon: 'CreditCard' as keyof typeof icons,
    pathname: '/accounting',
    title: 'Accounting',
    permissionKey: 'billing:admin',
    permission: [ROLE.SUPEROWNER]
  },
  {
    icon: 'Package' as keyof typeof icons,
    pathname: '/integrations',
    title: 'Integrations',
    permissionKey: 'mediaIntegrations:read',
  },
  {
    icon: 'PercentSquare' as keyof typeof icons,
    pathname: '/billing',
    title: 'Billing',
    permissionKey: 'billing:read',
  },
  {
    icon: 'LineChart' as keyof typeof icons,
    pathname: '/google-analytics',
    title: 'Google Analytics',
    permissionKey: 'insights:read',
  },
  {
    icon: 'Book' as keyof typeof icons,
    pathname: '/resources',
    title: 'Help & Resources',
  },
]

interface OrganizationsType {
  name: string;
  id: string;
}

const Organizations: OrganizationsType[] = [
  {
    name: 'Keep Me',
    id: '123',
  },
];

const TIME_FORMAT = 'h:mm A';
const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY-MM-DD h:mm:ss A';
const DATETIME_FORMAT_UTC = 'YYYY-MM-DD h:mm:ss';
export {
  AgentMap,
  Organizations,
  DATE_FORMAT,
  DATETIME_FORMAT,
  TIME_FORMAT,
  DATETIME_FORMAT_UTC,
  SalesMap,
  MultiAgentMap,
  ConversationAgentMap,
  AgentMapInsights,
  menuItems,
};
